<template>
  <div v-if="stripeStatus=='loaded'">
    <div class="stripe-elements-wrapper">
      <StripeElements
          :stripe-key="stripeKey"
          :instance-options="instanceOptions"
          :elements-options="elementsOptions"
          #default="{ elements }"
          ref="elms"
      >
        <StripeElement
            type="card"
            :elements="elements"
            :options="cardOptions"
            ref="card"
        />
      </StripeElements>
    </div>
  </div>
</template>

<script>
import {StripeElement, StripeElements} from "vue-stripe-elements-plus";

export default {
  name: "StripeForm",
  props: {
    tokenTrigger: {
      type: Number,
      required: true,
      default: 0,
    },
    handleCardPaymentTrigger: {
      type: Number,
      required: false,
      default: 0,
    },
    cardPaymentDetails: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      stripeKey: process.env.STRIPE_PK, // test key, don't hardcode
      instanceOptions: {
        // https://stripe.com/docs/js/initializing#init_stripe_js-options
      },
      elementsOptions: {
        // https://stripe.com/docs/js/elements_object/create#stripe_elements-options
      },
      cardOptions: {
        // reactive
        // remember about Vue 2 reactivity limitations when dealing with options
        style: {
          base: {
            color: '#000',
            fontFamily: 'minion-pro, serif',
            fontSmoothing: 'antialiased',
            fontSize: '20px',
            '::placeholder': {
              color: '#5A5A5A'
            },
            padding: '10px 0 15px 0',
            lineHeight: '23px',
          },
          invalid: {
            color: '#F22613',
            iconColor: '#F22613'
          },
        },
        value: {
          postalCode: ''
        }
        // https://stripe.com/docs/stripe.js#element-options
      },
      error: null,
      token: null,
    }
  },
  computed: {
    paymentFailed() {
      return this.error != null;
    },
    stripeInstance() {
      const groupComponent = this.$refs.elms
      return groupComponent.instance
    },
    stripeStatus() {
      return this.$store.getters.stripeStatus
    },
  },
  methods: {
    handleError(error) {
      this.error = error.message;
      this.$emit('on-error', this.error);
    },

    handleToken(token) {
      this.$emit('on-token', token)
    },

    resetError() {
      this.error = null;
    },

    createToken() {
      // ref in template
      const groupComponent = this.$refs.elms
      const cardComponent = this.$refs.card
      // Get stripe element
      const cardElement = cardComponent.stripeElement

      // Access instance methods, e.g. createToken()
      groupComponent.instance.createToken(cardElement).then(result => {
        if ('error' in result) {
          this.handleError(result.error)
        } else {
          this.handleToken(result.token)
        }
      })
    },

    async handleCardPayment() {
      const { client_secret } = this.cardPaymentDetails
      try {
        const result = await (client_secret.startsWith('seti') ?
          this.stripeInstance.confirmCardSetup(client_secret) :
          this.stripeInstance.handleCardPayment(client_secret));
        if (result.error) {
          this.handleError({ message: result.error.message })
        } else {
          this.$emit('on-handle-card-payment', result)
        }
      } catch (err) {
        this.handleError({ message: err })
      }
    },
  },

  mounted() {
    if (this.stripeStatus == 'none') {
      this.$store.dispatch('loadStripeLib')
    }
  },
  components: {
    StripeElements,
    StripeElement,
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    tokenTrigger(newVal, _oldVal) {
      if (newVal>0) {
        this.createToken();
      }
    },
    // eslint-disable-next-line no-unused-vars
    handleCardPaymentTrigger(newVal, _oldVal) {
      if (newVal>0) {
        this.handleCardPayment();
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.stripe-elements-wrapper {
  border-bottom: 2px solid $border-color;
  padding: 10px 0 15px 0;
}

</style>